


































































































































































import LookUp from '@/components/lookup/Index.vue'
import { EventBus, ON_SEARCH_PAGE_CREATE, ON_SEARCH_PAGE_DELETE, ON_SEARCH_PAGE_EDIT } from '@/eventbus'
import { clientDataSourceService } from '@/services'
import { ClientDataSource } from '@/types/ClientServiceType'
import Vue from 'vue'

function generateForm() {
    return {
        clientDataSource: {
           clientId: '',
            dataSource: '',
            dataSourceId: '',
        } as ClientDataSource,
        errors: {} as Record<string,string>,
        upsertDialog: false,
        deleteDialog: false,
        success: false,
        loading: false,
        deleteClientDataSource: {} as ClientDataSource,
        isUpdate: false
    }
}

export default Vue.extend({
    name: 'ClientDataSource',
    components: {
        LookUp
    },
    mounted() {
        EventBus.$on(ON_SEARCH_PAGE_CREATE, (pageName:string) => {
            if(pageName === this.$store.getters.currentPageConfig.pageName) {
                this.onClientDataSourceCreate()
            }
            
        })
        
        EventBus.$on(ON_SEARCH_PAGE_EDIT, (pageName:string, payload: ClientDataSource) => {
            if(pageName === this.$store.getters.currentPageConfig.pageName) { 
                this.onClientDataSourceUpdate(payload)
            }
            
        })

        EventBus.$on(ON_SEARCH_PAGE_DELETE, (pageName:string, payload: ClientDataSource) => {
            if(pageName === this.$store.getters.currentPageConfig.pageName) { 
                this.onClientDataSourceDelete(payload)
            }
            
        })
    },
    data(){
        return {
            form: generateForm()
        }
    },
    methods: {
        async onSave() {
            this.form.loading = true
            this.form.errors = {}
            this.form.success = false

            try{
               
                await clientDataSourceService.upsertClientDataSource(this.form.clientDataSource)
                this.form.success = true
            } catch (e) {
                if(this.axios.isAxiosError(e) && e?.response?.status == 400 && e.response.data && e.response.data.errors) {
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        this.form.errors[key] = value as string
                    }
                    
                    this.form.errors.General = 'There are errors that require your attention'
                } else {
                    this.form.errors.General = 'We\'re sorry, but we can\'t process your request at this time. Please try again later.'
                }
            }
            this.form.loading = false
        },
        async onDelete() {
            this.form.loading = true
            this.form.errors = {}
            this.form.success = false

            try{ 
                await clientDataSourceService.deleteClientDataSource(this.form.deleteClientDataSource)
                this.form.success = true
            } catch(e) {
                this.form.errors.General = 'There Are errors that require your attention'
            }
            this.form.loading = false
        },
        onResetForm() {
            this.form = generateForm()
        },
        onClientDataSourceCreate() {
            this.onResetForm()
            this.form.upsertDialog = true
        },
        onClientDataSourceUpdate(client: ClientDataSource) {
            this.onResetForm()
            this.form.clientDataSource = { ...client}
            this.form.isUpdate = true
            this.form.upsertDialog = true
        },
        onClientDataSourceDelete(client: ClientDataSource) {
            this.onResetForm()
            this.form.deleteClientDataSource = {...client}
            this.form.deleteDialog = true
        },
    }
})
